"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colours = _interopRequireDefault(require("../../theme/colours"));

var _default = [_colours["default"].azure, _colours["default"].watermelon, _colours["default"].prince, _colours["default"].lemon, _colours["default"].shamrock];
exports["default"] = _default;
//# sourceMappingURL=colours.js.map